import { api } from "@/lib/api/client";
import { commitOptions } from "@/lib/api/commitSeams";

/** One person's calendar address for one course. The token is never part of the state. */
export interface CalendarSubscriptionState {
  state: "none" | "active" | "stopped";
  created_at: string | null;
  revoked_at: string | null;
}

/**
 * The mint response is the only place the address ever appears: the first
 * answer to a key carries it, and a replay of the same key answers null (W1).
 */
export interface CalendarSubscriptionMint extends CalendarSubscriptionState {
  address: string | null;
}

/** Each command carries its key, so a lost answer is checked, never repeated (W1). */
export const calendarSubscriptionApi = {
  get: (courseId: string) => api.get<CalendarSubscriptionState>(`/courses/${courseId}/calendar-subscription`),
  mint: (courseId: string, key: string) =>
    api.post<CalendarSubscriptionMint>(`/courses/${courseId}/calendar-subscription`, undefined, commitOptions(key)),
  stop: (courseId: string, key: string) =>
    api.delete<CalendarSubscriptionState>(`/courses/${courseId}/calendar-subscription`, undefined, commitOptions(key)),
};
